import { Grid, Select, Typography } from "@mui/material";
import { MenuItemStyled } from "@entrilia/shared/components/MenuItemStyled";
import type { PeriodType } from "../../../../../../../../api/types/svTypes.ts";
import { availablePeriodTypes } from "../../../viewer/tile/utils/periodTypeUtils.ts";

interface Props {
  periodType: PeriodType;
  onChangePeriodType: (periodType: PeriodType) => void;
}

const PeriodDropdown = ({ periodType, onChangePeriodType }: Props) => {
  return (
    <Grid container sx={{ alignItems: "center", justifyContent: "space-between" }}>
      <Typography>Period</Typography>
      <Select value={periodType} sx={{ maxWidth: 208, width: "100%" }} disabled={true}>
        {availablePeriodTypes.map((item) => (
          <MenuItemStyled
            key={item.value}
            value={item.value}
            selected={item.value === periodType}
            onClick={() => onChangePeriodType(item.value as PeriodType)}
          >
            <Typography variant="caption">{item.text}</Typography>
          </MenuItemStyled>
        ))}
      </Select>
    </Grid>
  );
};

export default PeriodDropdown;
